import React, { useState, useContext, useEffect } from "react";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  FormFooter,
  Tag,
  Notification,
  ContentBlock
} from "xsolla-uikit";
import styled, { css, ThemeProvider } from "styled-components";

import { themes } from '../../data/themes'





export default function PS0 ({
  active,
  handleTab = () => {void(0)},
  items = [],
  appearance='primary',
  extra,
}) {
  return (
    <ThemeProvider theme={{
        ...themes[0],
        paddings: 8,
        fontSize: '14px',
        fontFamily: ' -apple-system, system-ui, Graphik LC Web, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Droid Sans, Helvetica Neue, Arial, sans-serif',
      }}>
    <CSSps00>
      <CSSps0>


      <CSSpsB>

        <CSScontentBlock appearance="flatten">


          <CSSpsFormGroup label="Cart">

            <CSSpsCartLine>
              <CSSpsCartPic/>
            </CSSpsCartLine>

          </CSSpsFormGroup>

          <CSSpsFormFooter>

              <Button appearance="secondary" size="sm">Check out</Button>
              <div className="">Subtotal:  <b>$29.81</b></div>

          </CSSpsFormFooter>

        </CSScontentBlock>

      </CSSpsB>

      <CSSpsF>
        Xsolla is an authorized video game software distributor providing clients with advanced technical tools for their games.
      </CSSpsF>

      </CSSps0>
    </CSSps00>
    </ThemeProvider>
  )
}






const CSSpsCartPic = styled.div`
  width: 64px;
  height: 64px;
  background: ${(props) => props.theme['colorText']};
  border-radius: ${(props) => `${props.theme['borderRadius']}px`};
`


const CSSpsCartLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const CSSpsFormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const CSSpsFormGroup = styled.div`
  padding: 0 0 ${(props) => `${props.theme['paddings'] * 3}px`} 0;
`
const CSScontentBlock = styled.div`
  padding: ${(props) => `${props.theme['paddings'] * 3}px`};
  position: relative;
  &::after {
    opacity: 0.05;
    content: '';
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;

    background: ${(props) => props.theme['colorText']};
    opacity: 0.1;
    border-radius: 2px;
  }
`


const CSSps00 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: black;
  min-height: 100vh;
`

const CSSps0 = styled.div`
  flex-direction: column;
  width: 600px;
  box-shadow: 0px 14px 64px rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  display: flex;
  align-items: space-between;
  justify-content: center;
  background: ${(props) => props.theme['colorBg']};
  font-size: ${(props) => props.theme['fontSize']};
  color: ${(props) => props.theme['colorText']};
`

const CSSpsF = styled.div`
  border-radius: 8px;
  padding: 44px;
  position: relative;
  &::after {
    opacity: 0.05;
    content: '';
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;

    background: ${(props) => props.theme['colorText']};
    opacity: 0.1;
    border-radius: 2px;
  }
`

const CSSpsB = styled.div`
  flex-grow: 1;
  padding: 44px;
`